module.exports = __webpack_public_path__ + "img/sign-back.327491c3.jpg";